import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { History, ChevronRight } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { Box, Dialog, DialogContent, DialogTitle, ListItem, ListItemText, Table } from '@otcmarketsgroup/otcm-ui-lib';
import { getVerificationHistory } from '../../api/cuf';
import { format } from '../../utils/format-locale';
import { testIds } from '../../constants/testIds';

const verificationColumns = [
    {
        id: 'action',
        header: 'Action',
    },
    {
        id: 'date',
        header: 'Date',
        renderCell: item => format(item.date, '-', 'date')
    }
];

const VerificationHistory = ({ symbol }) => {
    const [showDialog, setShowDialog] = useState(false);

    const { data: history = [] } = useQuery({
        queryKey: ['verificationHistory', symbol],
        queryFn: () => getVerificationHistory(symbol),
        enabled: !!symbol,
        select: data => Array.isArray(data) && data.length > 0 ? data : [],
    });

    if (!history.length) return null;

    return (
        <>
            <Box onClick={() => setShowDialog(true)} data-testid={testIds.controlPanel.verificationHistoryItem}>
                <ListItem
                    isButton
                    startIcon={<History color='var(--otc-green)' size={20} />}
                    endIcon={<ChevronRight color='var(--otc-green)' size={16} />}
                    alignIconToTop
                >
                    <ListItemText primary='See Verification History' />
                </ListItem>
            </Box>

            <Dialog open={showDialog} onClose={() => setShowDialog(false)} data-testid={testIds.controlPanel.verificationHistoryDialog}>
                <DialogTitle title={`${symbol} Verification History`} onClose={() => setShowDialog(false)} />
                <DialogContent>
                    <Box data-testid={testIds.controlPanel.verificationHistoryTable}>
                        <Table columns={verificationColumns} data={history} />
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
};

VerificationHistory.propTypes = {
    symbol: PropTypes.string.isRequired
};

export default VerificationHistory;